import { useTranslation } from 'react-i18next';
import { BookingForm } from '@/features/booking/BookingForm';

export function BookingPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-5">
      <header>
        <h1 className="headline text-[22px] uppercase tracking-[0.02em]">
          {t('booking.title')}
        </h1>
        <div className="hairline mt-2 w-12" />
      </header>
      <BookingForm />
    </div>
  );
}
